var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOption3LinesWithDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 1.75H18.25M6.25 7H18.25M6.25 12.25H18.25M1.75 1.75H1.7575V1.7575H1.75V1.75ZM2.125 1.75C2.125 1.95711 1.95711 2.125 1.75 2.125C1.54289 2.125 1.375 1.95711 1.375 1.75C1.375 1.54289 1.54289 1.375 1.75 1.375C1.95711 1.375 2.125 1.54289 2.125 1.75ZM1.75 7H1.7575V7.0075H1.75V7ZM2.125 7C2.125 7.20711 1.95711 7.375 1.75 7.375C1.54289 7.375 1.375 7.20711 1.375 7C1.375 6.79289 1.54289 6.625 1.75 6.625C1.95711 6.625 2.125 6.79289 2.125 7ZM1.75 12.25H1.7575V12.2575H1.75V12.25ZM2.125 12.25C2.125 12.4571 1.95711 12.625 1.75 12.625C1.54289 12.625 1.375 12.4571 1.375 12.25C1.375 12.0429 1.54289 11.875 1.75 11.875C1.95711 11.875 2.125 12.0429 2.125 12.25Z",
    stroke: "#001F68",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOption3LinesWithDots);
export default __webpack_public_path__ + "static/media/option-3-lines-with-dots.d797534a5b1799b9cd1234eb069a8be1.svg";
export { ForwardRef as ReactComponent };